import React, { useState } from 'react';
import bgImage from '../assets/bk.jpg'; // make sure this exists in src/assets
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Card } from 'react-bootstrap';

function Signup() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  const handleSignup = (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert('Passwords do not match!');
      return;
    }

    const users = JSON.parse(localStorage.getItem('users') || '[]');
    if (users.find((u) => u.email === email)) {
      alert('User already exists!');
      return;
    }

    const newUser = { name, email, password };
    users.push(newUser);
    localStorage.setItem('users', JSON.stringify(users));

    alert('Account created successfully!');
    navigate('/login');
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
      }}
    >
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Card
          style={{
            width: '100%',
            maxWidth: '420px',
            borderRadius: '15px',
            padding: '20px',
            background: 'rgba(255, 255, 255, 0.15)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            color: 'white',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 8px 20px rgba(0,0,0,0.3)'
          }}
        >
          <Card.Body>
            <h2 className="text-center mb-4" style={{ color: '#fff' }}>
              Create Account
            </h2>
            <Form onSubmit={handleSignup}>
              <Form.Group className="mb-3">
                <Form.Label style={{ color: '#fff' }}>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your full name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  style={{
                    borderRadius: '8px',
                    padding: '10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    color: '#000'
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label style={{ color: '#fff' }}>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    borderRadius: '8px',
                    padding: '10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    color: '#000'
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label style={{ color: '#fff' }}>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter a password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{
                    borderRadius: '8px',
                    padding: '10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    color: '#000'
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label style={{ color: '#fff' }}>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Confirm your password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  style={{
                    borderRadius: '8px',
                    padding: '10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    color: '#000'
                  }}
                />
              </Form.Group>

              <Button
                type="submit"
                variant="primary"
                className="w-100"
                style={{ borderRadius: '8px', padding: '10px' }}
              >
                Sign Up
              </Button>
              <Button
  variant="link"
  className="w-100 mt-2"
  onClick={() => navigate('/')}
>
  Already have an account? Login
</Button>

            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default Signup;
